import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow, MaskLines } from "../site/Reveal";

export const AboutTeaser = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="about-teaser" className="bg-paper py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] [clip-path:polygon(0_0,100%_0,100%_88%,82%_100%,0_100%)]">
            <motion.img style={{ y, scale: 1.2 }} src="/images/pen.jpg" alt="Fountain pen on paper" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-[#0a1424]/20" />
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <Eyebrow>The firm</Eyebrow>
          <h2 className="mt-6 font-display font-extrabold tracking-[-0.035em] leading-[0.98] text-4xl sm:text-5xl lg:text-6xl">
            <MaskLines inView lines={["A practising CS firm", <>built for <span className="font-serif-i text-[var(--brass-deep)]">intermediaries.</span></>]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base sm:text-lg text-ink/75 leading-relaxed max-w-2xl">
              Jay Kular &amp; Associates is a proprietorship firm of Practising Company Secretaries, founded in April 2026 by Jay Kular — who brings more than a decade of experience in capital-market compliance.
            </p>
            <p className="mt-5 text-base sm:text-lg text-ink/75 leading-relaxed max-w-2xl">
              We specialise in comprehensive compliance, regulatory advisory, audit and documentation services to SEBI-regulated entities.
            </p>
            <Link to="/about" data-testid="about-teaser-link" className="group mt-10 inline-flex items-center gap-2 font-semibold border-b border-ink pb-1 hover:text-[var(--brass-deep)] hover:border-[var(--brass-deep)] transition-colors">
              About the firm <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
